import ApiCall from "../constants/Api";
import SiteConfig from "../constants/SiteConfig";
import { helpAxios } from "../helpers/helpAxios";
import { errorHandler } from "../components/ErrorHandler";

export const useUpdateFunctions = () => {
  //Call method UpdateEmailConfig
  const updateEmailConfig = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        ApiCall.UPDATE_EMAIL_CONFIG,
        {
          ...request,
        },
        LogonSessionID,
        SiteConfig.USER_ACCESS_SVC,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  return {
    updateEmailConfig,
  };
};
